/* AD Perfumes — product page: size/variant selection and gallery.
   The selected size always maps to a real Shopify variant. Prices, stock and
   SKU are re-rendered by Shopify (Section Rendering API), never calculated here. */
(function () {
  'use strict';

  var ADP = (window.ADP = window.ADP || {});
  var strings = ADP.strings || {};
  var settings = ADP.settings || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  /* ---------- Gallery ---------- */
  function Gallery(root) {
    this.root = root;
    this.track = root.querySelector('[data-gallery-track]');
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    if (!this.track) return;
    var self = this;

    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { self.goTo(thumb.getAttribute('data-gallery-thumb')); });
    });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { self.step(-1); });
    if (next) next.addEventListener('click', function () { self.step(1); });

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) self.setActive(entry.target.getAttribute('data-media-id'));
        });
      }, { root: this.track, threshold: 0.6 });
      this.track.querySelectorAll('[data-media-id]').forEach(function (item) { self.observer.observe(item); });
    }
  }
  Gallery.prototype.items = function () {
    return Array.prototype.slice.call(this.track.querySelectorAll('[data-media-id]'));
  };
  Gallery.prototype.goTo = function (mediaId) {
    var item = this.track.querySelector('[data-media-id="' + mediaId + '"]');
    if (!item) return;
    var left = item.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
    this.track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
    this.setActive(String(mediaId));
  };
  Gallery.prototype.step = function (dir) {
    var items = this.items();
    var current = this.activeId ? items.findIndex(function (i) { return i.getAttribute('data-media-id') === this.activeId; }, this) : 0;
    var nextIndex = (Math.max(current, 0) + dir + items.length) % items.length;
    this.goTo(items[nextIndex].getAttribute('data-media-id'));
  };
  Gallery.prototype.setActive = function (mediaId) {
    this.activeId = String(mediaId);
    this.thumbs.forEach(function (t) {
      var active = t.getAttribute('data-gallery-thumb') === String(mediaId);
      t.classList.toggle('is-active', active);
      if (active) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  };

  /* ---------- Product section ---------- */
  function ProductSection(section) {
    this.section = section;
    this.sectionId = section.getAttribute('data-section-id');
    this.productUrl = section.getAttribute('data-product-url');
    this.form = document.getElementById(section.getAttribute('data-form-id'));
    this.picker = section.querySelector('[data-variant-picker]');
    var galleryEl = section.querySelector('[data-gallery]');
    this.gallery = galleryEl ? new Gallery(galleryEl) : null;
    this.requestId = 0;

    if (!this.picker) return;
    var json = this.picker.querySelector('[data-variants-json]');
    try {
      this.variants = JSON.parse(json ? json.textContent : '[]');
    } catch (e) {
      this.variants = [];
    }
    var self = this;
    this.picker.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input], [data-option-select]')) self.onOptionChange();
    });
  }

  ProductSection.prototype.selectedOptions = function () {
    return Array.prototype.map.call(this.picker.querySelectorAll('[data-option-index]'), function (fs) {
      var checked = fs.querySelector('[data-option-input]:checked');
      if (checked) return checked.getAttribute('data-option-value') || checked.value;
      var select = fs.querySelector('[data-option-select]');
      if (!select) return null;
      var opt = select.options[select.selectedIndex];
      return (opt && opt.getAttribute('data-option-value')) || select.value;
    });
  };

  ProductSection.prototype.onOptionChange = function () {
    var options = this.selectedOptions();
    var variant = this.variants.find(function (v) { return arraysEqual(v.options, options); }) || null;

    // Update "Size: 20ml" labels
    this.picker.querySelectorAll('[data-option-index]').forEach(function (fs, i) {
      var label = fs.querySelector('[data-selected-value]');
      if (label) label.textContent = ': ' + options[i];
    });

    this.updateButton(variant);
    if (!variant) return;

    var idInput = this.form && this.form.querySelector('[data-variant-id-input]');
    if (idInput) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (variant.featured_media && this.gallery) this.gallery.goTo(variant.featured_media.id);
    this.renderVariantDetails(variant.id);
  };

  ProductSection.prototype.updateButton = function (variant) {
    if (!this.form) return;
    var btn = this.form.querySelector('[data-add-button]');
    if (!btn) return;
    var label = btn.querySelector('[data-add-label]');
    var custom = btn.getAttribute('data-custom-label');
    var text;
    var disabled = true;
    if (!variant) {
      text = strings.unavailable;
    } else if (settings.blockZeroPrice && Number(variant.price) === 0) {
      text = strings.priceMissing;
    } else if (!variant.available) {
      text = strings.soldOut;
    } else {
      text = custom || strings.addToBag;
      disabled = false;
    }
    btn.disabled = disabled;
    if (label) label.textContent = text;
    if (ADP.setFormMessage) ADP.setFormMessage(this.form, '', null);
  };

  // Ask Shopify to render this section for the chosen variant, then swap in the
  // price / stock / SKU blocks so money formatting stays exactly as configured.
  ProductSection.prototype.renderVariantDetails = function (variantId) {
    var self = this;
    var requestId = ++this.requestId;
    var url = this.productUrl + (this.productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId + '&section_id=' + encodeURIComponent(this.sectionId);
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        if (requestId !== self.requestId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['price', 'inventory', 'sku'].forEach(function (key) {
          var current = self.section.querySelector('[data-update="' + key + '"]');
          var fresh = doc.querySelector('[data-update="' + key + '"]');
          if (current && fresh) current.innerHTML = fresh.innerHTML;
        });
        var qtyCurrent = self.section.querySelector('.quantity__input');
        var qtyFresh = doc.querySelector('.quantity__input');
        if (qtyCurrent && qtyFresh) {
          ['min', 'max', 'step'].forEach(function (attr) {
            if (qtyFresh.hasAttribute(attr)) qtyCurrent.setAttribute(attr, qtyFresh.getAttribute(attr));
            else qtyCurrent.removeAttribute(attr);
          });
        }
      })
      .catch(function () {
        // If the live update fails, reload so the shopper never sees a stale price.
        if (requestId === self.requestId) window.location.reload();
      });
  };

  function init(root) {
    (root || document).querySelectorAll('[data-product-section]').forEach(function (section) {
      if (section.__adpProduct) return;
      section.__adpProduct = new ProductSection(section);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
